import { Component, OnInit, Input } from '@angular/core';
import { DocumentDownload } from '../model/document-download.model';
import { CommunicationService } from '../communication.service';
import { CrawfordSnackbarService, CrawfordDownloadService } from 'crawford-shell';

@Component({
  selector: 'app-document-download',
  templateUrl: './document-download.component.html',
  styleUrls: ['./document-download.component.scss']
})
export class DocumentDownloadComponent implements OnInit {
  @Input() public details: DocumentDownload;
  @Input() public crawfordRef: string;
  protected isRequestingDownload = false;

  constructor(
    private communicationService: CommunicationService,
    private snackbarService: CrawfordSnackbarService,
    private downloadService: CrawfordDownloadService
  ) { }

  ngOnInit() {
  }

  public openDocument() {
    this.isRequestingDownload = true;

    this.communicationService.getOpenDocument(this.crawfordRef, this.details.id.toString()).subscribe(
      response => {
        if (response) {
          this.downloadService.downloadFileFromResponse(response, this.details.name);
        } else {
          this.snackbarService.displayErrorMessage('Unable to download document ' + this.details.name);
        }

        this.isRequestingDownload = false;
      },
      error => {
        this.isRequestingDownload = false;
      });
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/communication/document-download/document-download.component.ts